import React from 'react'
import {connect} from 'react-redux';
import Overview from '../components/report/overview';
import LanguagesFilter from "../components/report/languages_filter"
import {Actions,SideBar} from "../components/report/executive_summary_components"

import {collapseSections} from "../state/actions/app"

const mapDispatchAsProps = dispatch =>({
    collapse: (current)=>dispatch(collapseSections("all", current))
})


const mapStateAsProps = state =>({
    state: state,
	isExperimental: state.projectInfo.isExperimental,
	urlParams: state.projectInfo.urlParams,
	report: state.projectInfo.report,
	summary: state.projectInfo.summary,
	reportOriginal: state.projectInfo.reportOriginal,
	projectInfo: state.projectInfo.projectInfo,
	titleState: state.projectInfo.titleState,
	hasError: state.projectInfo.errorReport,
	isLatestReport: state.projectInfo.isLatestReport,
	exclusions: state.projectInfo.exclusionsMap,
	user: state.setUser.user,
	hasLicenses: state.projectInfo.titleState.hasLicenses,
    collapsed: state.summariesState.executive,
    security: state.projectInfo.security,
    stability: state.projectInfo.stability,
    licensing: state.projectInfo.licensing

})


class ExecutiveSummary extends React.Component{

    render(){

        const summary = {
            security: this.props.security.summary,
            stability: this.props.stability.summary,
            licensing: this.props.licensing.summary
        }

        return(
            <React.Fragment>
                <div className="container-fluid">
					<div className="row">
						<div className="col-md-6">
                            <h3 className="mt-1 report-header d-inline"><i className="fas fa-chart-line mr-2" style={{color:'gray'}}></i>EXECUTIVE SUMMARY</h3> 
                            <i tabIndex={0} className={(this.props.collapsed?"fa-plus-square":"fa-minus-square")+" far fa-lg section-minimizer ml-2" } onClick={()=>this.props.collapse(this.props.collapsed)} onKeyUp={(e)=>{if(e.key.toLocaleLowerCase()=="enter") this.props.collapse(this.props.collapsed)}}></i>
                        </div>
                        {this.props.collapsed? "": 
						    <LanguagesFilter/>
                        }
					</div>
				</div>
                {
                    this.props.collapsed?
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-6">
                                <Overview ready={this.props.overviewReady} renderId={this.props.renderId} collapsed={true}/>
                            </div>
                            <div className="col-lg-6">
 
                                <Actions issues={this.props.issues} partialBuild={this.props.partialBuild} shouldShowLicenses={this.props.hasLicenses} report = {this.props.report} summary = {summary} collapsed={true}/>
                            </div>


                        </div>
                    </div>:
                    <React.Fragment>
                        <Overview ready={this.props.overviewReady} renderId={this.props.renderId} />
                        <div className="row">
                            <Actions issues={this.props.issues} partialBuild={this.props.partialBuild} shouldShowLicenses={this.props.hasLicenses} report = {this.props.report} summary = {summary}/>
                            <SideBar timestamp={this.props.timestamp} urlParams={this.props.urlParams} display={this.props.display} summary = {summary} scopes={this.props.scopes}/>
                        </div>
                    </React.Fragment>
                }
            </React.Fragment>
        )
    }
}

export default connect(mapStateAsProps, mapDispatchAsProps)(ExecutiveSummary)